import { gql } from '@apollo/client';

export const REGENERATE_QRCODE = gql`
  mutation regenerateQrcode( $contractId: String!) {
    regenerateQrcode( contractId: $contractId) {
      contract {
        credentials {
          type
          value
        }
      }
    }
  }
`;
